import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

import auth from './modules/auth'
import courses from './modules/courses'
import categories from './modules/categories'
import subcategories from './modules/subcategories'
import filters from './modules/filters'
import ranges from './modules/ranges'
import hands from './modules/hands'
import decks from './modules/decks'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showModal: false,
    selectedItem: {
      title: '',
      description: ''
    },
    rangeEdit: false,
    selectedRange: {
      title: '',
      description: '',
      color: 'gray',
      hands: []
    }
  },
  getters,
  actions,
  mutations,
  modules: {
    auth,
    courses,
    categories,
    subcategories,
    filters,
    ranges,
    hands,
    decks
  }
})
